'use es6';

import getIn from 'transmute/getIn';
export const getInputFocus = state => {
  return getIn(['widgetInputFocusStatus', 'widgetInputIsOnFocus'], state);
};